var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStopCircle = function SvgStopCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 1.988c5.53 0 10.012 4.483 10.012 10.012S17.529 22.012 12 22.012 1.99 17.529 1.988 12C1.988 6.47 6.471 1.989 12 1.988m0 1.2a8.813 8.813 0 0 0 0 17.624 8.812 8.812 0 0 0 0-17.624m1.883 5.488c.796 0 1.441.645 1.441 1.441v3.765c0 .796-.645 1.441-1.441 1.441h-3.765a1.44 1.44 0 0 1-1.441-1.441v-3.765c0-.796.645-1.441 1.441-1.441zm-3.765 1a.44.44 0 0 0-.441.441v3.765c0 .244.198.441.441.441h3.765a.44.44 0 0 0 .441-.441v-3.765a.44.44 0 0 0-.441-.441z"
  })));
};
export default SvgStopCircle;